<template>
  <v-page white>
    <template v-if="isLoading">
      <div class="p-overlay">
        <v-loader />
      </div>
    </template>

    <template v-else-if="currentForm">
      <form-template
        hide-close
        inline
        v-model="currentValues"
        :id="currentForm.id"
        :title="currentForm.title"
        :groups="currentForm.form_groups"
        :submittedHeading="currentForm.submitted_heading"
        :submittedDescription="currentForm.submitted_description"
        :showIntroScreen="currentForm.show_intro_screen"
        :introHeading="currentForm.intro_heading"
        :introDescription="currentForm.intro_description"
      />
    </template>
  </v-page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  components: {
    FormTemplate: () => import("@/components/page-templates/FormTemplate")
  },

  data() {
    return {
      isLoading: false,
      currentForm: null
    }
  },

  mounted() {
    this.fetchAndShowForm()
  },

  computed: {
    ...mapGetters("forms", ["formById", "submissionValuesByForm"]),

    currentValues: {
      get() {
        return this.formValues
      },

      set(values) {
        for (const fieldId in values) {
          this.updateFormSubmissionValue({
            formId: this.formId,
            fieldId,
            data: {
              ...(this.formValues[fieldId] || {}),
              ...(values[fieldId] || {})
            }
          })
        }
      }
    },

    formValues() {
      return this.submissionValuesByForm(this.formId)
    },

    formId() {
      return this.$route.params.id
    }
  },

  methods: {
    ...mapActions("forms", ["fetchForm"]),
    ...mapMutations("forms", ["updateFormSubmissionValue"]),
    ...mapActions("analytics", ["trackFormViewed"]),

    fetchAndShowForm() {
      const savedForm = this.formById(this.formId)

      if (savedForm) {
        this.currentForm = savedForm
        this.trackFormViewed({
          form: this.currentForm
        })
      } else {
        this.isLoading = true

        this.fetchForm(this.formId)
          .then(form => {
            this.currentForm = form
            this.trackFormViewed({
              form: this.currentForm
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>
